module.exports = __webpack_public_path__ + "components/star-rating/static/white/0-c12f238a5d57b34414400288e355ba92.svg";